import CopyLinkDialog from "./views/CopyLinkDialog";

const routes = [
  {
    path: "/copy-link",
    name: "copy-link",
    component: CopyLinkDialog
  }
];

export default routes;
